// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#forgot[data-v-10d9df09] {\n  padding: 1em 0;\n}\n.m-fadeOut[data-v-10d9df09] {\n  visibility: hidden;\n  opacity: 0;\n  height: 0;\n  padding-top: 0;\n  padding-bottom: 0;\n  transition: visibility 0s linear 600ms, opacity 600ms, height 600ms,\n    padding-top 600ms;\n}\n.m-fadeIn[data-v-10d9df09] {\n  visibility: visible;\n  opacity: 1;\n  transition: visibility 0s linear 0s, opacity 600ms, height 600ms,\n    padding-top 600ms, padding-bottom 600ms;\n}\n", ""]);
// Exports
module.exports = exports;
